/* eslint-disable @typescript-eslint/no-explicit-any */

import { css } from '@emotion/react/macro';
import styled from '@emotion/styled/macro';
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  CardCvcElementProps,
  CardExpiryElementProps,
  CardNumberElementProps,
} from '@stripe/react-stripe-js';
import { Box, Flex, WithCSSVar, FormLabel } from '@chakra-ui/react';
import { Dict } from '@chakra-ui/utils';

export const baseInputStyle = css`
  box-sizing: border-box;
  line-height: 180%;
  font-weight: normal;
  appearance: none;
  box-shadow: none;
  padding-left: 20px;
  padding-top: 20px;
  height: 60px;
`;

interface ThemeProps {
  theme: WithCSSVar<Dict<any>>;
  forCorporate?: boolean;
}

export const StyledCardNumberElement = styled(CardNumberElement)<CardNumberElementProps & ThemeProps>`
  ${baseInputStyle}
  border-radius: ${({ theme }) => theme.radii.base};
  border: 1px solid ${({ theme }) => theme.colors.secondary[300]};
  font-size: ${({ theme }) => theme.fonts.lgMin};
  background: ${({ theme }) => theme.colors.white};
  height: ${({ forCorporate }) => (forCorporate ? '50px' : '60px')};
  padding-top: ${({ forCorporate }) => (forCorporate ? '15px' : '20px')};
`;

export const StyledCardExpiryElement = styled(CardExpiryElement)<CardExpiryElementProps & ThemeProps>`
  ${baseInputStyle}
  border-radius: ${({ theme }) => theme.radii.base};
  border: 1px solid ${({ theme }) => theme.colors.secondary[300]};
  font-size: ${({ theme }) => theme.fonts.lgMin};
  height: ${({ forCorporate }) => (forCorporate ? '50px' : '60px')};
  padding-top: ${({ forCorporate }) => (forCorporate ? '15px' : '20px')};
`;

export const StyledCardCvcElement = styled(CardCvcElement)<CardCvcElementProps & ThemeProps>`
  ${baseInputStyle}
  border-radius: ${({ theme }) => theme.radii.base};
  border: 1px solid ${({ theme }) => theme.colors.secondary[300]};
  font-size: ${({ theme }) => theme.fonts.lgMin};
  height: ${({ forCorporate }) => (forCorporate ? '50px' : '60px')};
  padding-top: ${({ forCorporate }) => (forCorporate ? '15px' : '20px')};
`;

export const Label = styled(FormLabel)`
  font-weight: 500;
  margin-bottom: 6px;
`;

export const InformationWrapper = styled(Flex)<{ pinkBorder: boolean } & ThemeProps>`
  border: 1px solid
    ${({ pinkBorder, theme, forCorporate }): string =>
      pinkBorder ? theme.colors.primary[500] : forCorporate ? theme.colors.secondary[100] : theme.colors.secondary[300]};
  box-sizing: border-box;
  border-radius: ${({ theme }) => theme.radii.base};
  background: ${({ theme, forCorporate }) => (forCorporate ? theme.colors.secondary[100] : 'transparent')};
`;

export const ConsentText = styled(Box)`
  font-weight: 500;
`;
